import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.iterator.reduce.js";
import "core-js/modules/es.iterator.some.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.set.difference.v2.js";
import "core-js/modules/es.set.intersection.v2.js";
import "core-js/modules/es.set.is-disjoint-from.v2.js";
import "core-js/modules/es.set.is-subset-of.v2.js";
import "core-js/modules/es.set.is-superset-of.v2.js";
import "core-js/modules/es.set.symmetric-difference.v2.js";
import "core-js/modules/es.set.union.v2.js";
import { oneClickDownstreamSyncConfig, saveDownstreamSyncConfig, testDownstreamConnection } from "@/service/sync-manage";
import { formatTime, systemName } from "./sync-utils";
const DEFAULT_CONFIG_SYSTEMS = ["UC", "IHOTEL", "ICATER"];
const CONFIG_DATA_FIELDS = ["id", "enabled", "channelId", "channelUuid", "webhookEndpoint", "downstreamBaseUrl", "deploymentType", "channelType", "syncMode", "channelName", "syncDirectionText", "scopeText", "triggerText", "pullInterval", "pullIntervalText"];
const OVERVIEW_DATA_FIELDS = ["enabled", "channelId", "channelUuid", "webhookEndpoint", "downstreamBaseUrl", "deploymentType", "channelType", "syncMode", "channelName", "successCount", "failedCount", "unackedCount", "noneCount", "lastPushTime", "lastPullTime", "lastStatusTime", "lastAckTime", "pullInterval", "pullIntervalText"];
export default {
  name: "sync-config-tab",
  props: {
    active: {
      type: Boolean,
      default: false
    },
    appId: {
      type: String,
      default: ""
    },
    unitCode: {
      type: String,
      default: ""
    },
    configs: {
      type: Array,
      default() {
        return [];
      }
    },
    overview: {
      type: Object,
      default() {
        return {};
      }
    },
    downstreamOptions: {
      type: Array,
      default() {
        return [];
      }
    },
    activeSystem: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      saving: false,
      autoFetching: false,
      testing: false,
      currentSystem: "",
      queryUrl: "",
      localConfigs: {},
      connectionResults: {},
      connectionStatusMap: {},
      probingSystems: {}
    };
  },
  computed: {
    systemTabs() {
      // 配置页默认展示三套业务系统，接口未返回前只保留结构，不填充配置值。
      const systems = [...DEFAULT_CONFIG_SYSTEMS, ...this.downstreamOptions.map(item => item.value), ...this.configs.map(item => item.downstreamSystem), ...(this.overview.downstreams || []).map(item => item.downstreamSystem)].filter(Boolean);
      return [...new Set(systems)].map(system => ({
        value: system
      }));
    },
    currentConfig() {
      const remoteConfig = this.configs.find(item => item.downstreamSystem === this.currentSystem) || {};
      return {
        ...remoteConfig,
        ...(this.localConfigs[this.currentSystem] || {})
      };
    },
    currentOverview() {
      return (this.overview.downstreams || []).find(item => item.downstreamSystem === this.currentSystem) || {};
    },
    shortName() {
      return this.shortSystemName(this.currentSystem);
    },
    hasCurrentConfigData() {
      return this.hasAnyField(this.currentConfig, CONFIG_DATA_FIELDS);
    },
    hasCurrentOverviewData() {
      return this.hasAnyField(this.currentOverview, OVERVIEW_DATA_FIELDS);
    },
    hasCurrentData() {
      return this.hasCurrentConfigData || this.hasCurrentOverviewData;
    },
    isEnabled() {
      if (!this.hasCurrentData) return null;
      const enabled = this.currentConfig.enabled !== undefined ? this.currentConfig.enabled : this.currentOverview.enabled;
      return Boolean(enabled);
    },
    warningCount() {
      const rootCauseAlertCount = this.currentRootCauseAlertCount();
      if (rootCauseAlertCount !== null) return rootCauseAlertCount;
      return this.toNumber(this.currentOverview.alertCount) || this.toNumber(this.currentOverview.pendingAlertCount) || this.toNumber(this.currentOverview.failedCount) + this.toNumber(this.currentOverview.unackedCount);
    },
    currentConnectionStatus() {
      return this.connectionStatusMap[this.currentSystem] || null;
    },
    currentConnectionFailed() {
      var _this$currentConnecti;
      // 手动点击测试连通性后，顶部同步状态要立即跟随当前测试结果变化，再回退到静默探活缓存。
      if (this.connectionResult) {
        return this.connectionResult.status === "error";
      }
      return Boolean((_this$currentConnecti = this.currentConnectionStatus) === null || _this$currentConnecti === void 0 ? void 0 : _this$currentConnecti.failed);
    },
    statusClass() {
      // 同一业务系统同时存在告警与连通性异常时，状态展示优先突出“有告警”。
      if (this.warningCount > 0) return "warning";
      return this.currentConnectionFailed ? "error" : "success";
    },
    statusText() {
      if (this.warningCount > 0) return $t("fiejp3", "有告警");
      return this.currentConnectionFailed ? $t("ika8634", "连接失败") : $t("lpxkh3", "运行中");
    },
    statusRows() {
      return [{
        label: $t("it3h0p4", "部署形态"),
        value: this.deploymentText,
        tag: this.deploymentText !== "—",
        tagClass: this.isPushSystem ? "blue" : "purple"
      }, {
        label: $t("b1ujo14", "同步方向"),
        value: this.directionText
      }, {
        label: $t("b1zjl64", "同步范围"),
        value: this.scopeText
      }, {
        label: $t("hqwz8h4", "触发方式"),
        value: this.triggerText
      }, {
        label: $t("dl5u964", "最近同步"),
        value: formatTime(this.lastSyncTime),
        className: "mono"
      }, {
        label: $t("ad37n84", "今日同步"),
        value: this.todaySyncText
      }];
    },
    isPushSystem() {
      const channelText = String(this.currentConfig.channelType || this.currentOverview.channelType || this.currentConfig.syncMode || this.currentOverview.syncMode || this.currentConfig.channelName || this.currentOverview.channelName || "").toUpperCase();
      if (channelText) {
        return !channelText.includes("PULL") && !channelText.includes($t("h9gt2", "拉取"));
      }
      return ["UC", "ICATER"].includes(this.currentSystem);
    },
    deploymentText() {
      const deploymentType = this.currentConfig.deploymentType || this.currentOverview.deploymentType;
      if (deploymentType) {
        const normalizedType = String(deploymentType).toUpperCase();
        if (normalizedType === "SAAS") return "SaaS";
        if (["PRIVATE", "PRIVATIZATION"].includes(normalizedType)) {
          return $t("ibzji3", "私有化");
        }
        return deploymentType;
      }
      if (!this.hasCurrentData) return "—";
      return this.isPushSystem ? "SaaS" : $t("ibzji3", "私有化");
    },
    directionText() {
      if (this.currentConfig.syncDirectionText) {
        return this.currentConfig.syncDirectionText;
      }
      if (!this.hasCurrentData) return "—";
      return this.isPushSystem ? $t("v8gywn10", "iWork \u4E3B\u52A8\u63A8\u9001\u81F3 ${this.shortName}\uFF08\u540C\u7EFF\u4E91\u4E91\u5185\uFF09", {
        "this.shortName": this.shortName
      }) : `${this.shortName}${" " + $t('wyj5zoo', '主动从 iWork 出站拉取（无需开放入站端口）') + ""}`;
    },
    scopeText() {
      if (!this.hasCurrentData) return "—";
      return this.currentConfig.scopeText || $t("ng582dc", "全单位成员（含所有部门）");
    },
    triggerText() {
      if (this.currentConfig.triggerText) return this.currentConfig.triggerText;
      if (!this.hasCurrentData) return "—";
      return this.isPushSystem ? $t("pwm1ksh", "iWork 自驱，数据变更实时触发") : $t("j82tv21s", "iWork \u81EA\u9A71\u4EA7\u751F\u53D8\u66F4\u4E8B\u4EF6 \xB7 ${this.shortName} ${this.pullIntervalText} \u95F4\u9694\u62C9\u53D6", {
        "this.shortName": this.shortName,
        "this.pullIntervalText": this.pullIntervalText
      });
    },
    lastSyncTime() {
      if (!this.hasCurrentOverviewData) return "";
      return this.isPushSystem ? this.currentOverview.lastPushTime || this.currentOverview.lastStatusTime || this.currentOverview.lastAckTime : this.currentOverview.lastPullTime || this.currentOverview.lastPushTime || this.currentOverview.lastStatusTime || this.currentOverview.lastAckTime;
    },
    todaySyncText() {
      if (!this.hasCurrentOverviewData) return "—";
      const todaySyncCount = this.firstNumber(this.currentOverview, ["todaySyncCount", "todaySyncedMemberCount", "successCount"]);
      const rate = this.currentOverview.todaySuccessRate !== undefined && this.currentOverview.todaySuccessRate !== null ? this.normalizeTodaySuccessRate(this.currentOverview.todaySuccessRate) : (() => {
        const successCount = this.toNumber(this.currentOverview.successCount);
        const failedCount = this.toNumber(this.currentOverview.failedCount);
        const total = successCount + failedCount;
        return total ? Math.round(successCount / total * 100) : 100;
      })();
      return `${todaySyncCount || 0}${" " + $t('ltpfzk7', '次 · 成功率') + " "}${rate}%`;
    },
    pullIntervalText() {
      return this.currentConfig.pullInterval || this.currentOverview.pullInterval || this.currentOverview.pullIntervalText || "—";
    },
    connectionResult() {
      return this.connectionResults[this.currentSystem] || null;
    },
    connectionTip() {
      return $t("mbf2dt1w", "\u70B9\u51FB\u300C\u6D4B\u8BD5\u8FDE\u901A\u6027\u300D\u9A8C\u8BC1 iWork \u4E0E ${this.shortName} \u540C\u6B65\u901A\u9053\u662F\u5426\u7545\u901A\u3002\u540C\u6B65\u5F02\u5E38\u65F6\u53EF\u624B\u52A8\u6D4B\u8BD5\uFF0C\u6392\u67E5\u7F51\u7EDC/\u9274\u6743\u95EE\u9898\u3002", {
        "this.shortName": this.shortName
      });
    },
    queryTip() {
      return $t("6v5n7t1x", "iWork \u901A\u8FC7\u6B64\u5730\u5740\u5B9E\u65F6\u67E5\u8BE2 ${this.shortName} \u8D26\u53F7\u72B6\u6001\uFF08\u5BF9\u8D26\u4E0E\u6392\u9519\uFF09\u3002\u70B9\u300C\u81EA\u52A8\u83B7\u53D6\u300D\u8C03\u7528\u4E00\u952E\u914D\u7F6E\u751F\u6210\u6216\u590D\u7528\u540C\u6B65\u914D\u7F6E\u3002", {
        "this.shortName": this.shortName
      });
    },
    // iHotel 查询接口需要额外提示专网/出站访问要求，避免客户误以为保存地址后即可直接连通。
    showIHotelQueryNotice() {
      return this.currentSystem === "IHOTEL";
    }
  },
  watch: {
    activeSystem: {
      immediate: true,
      handler(value) {
        if (value) this.currentSystem = value;
        this.ensureCurrentSystem();
        this.fillQueryUrl();
      }
    },
    configs: {
      deep: true,
      handler(value) {
        this.clearLocalConfigsByRemote(value);
        this.ensureCurrentSystem();
        this.fillQueryUrl();
      }
    },
    overview: {
      deep: true,
      handler() {
        this.ensureCurrentSystem();
        this.fillQueryUrl();
      }
    }
  },
  methods: {
    // 判断当前系统是否已有接口返回的有效字段，避免默认 Tab 渲染前端假值。
    hasAnyField(source = {}, fields = []) {
      return fields.some(field => {
        const value = source[field];
        return value !== undefined && value !== null && value !== "";
      });
    },
    toNumber(value) {
      const numberValue = Number(value);
      return Number.isFinite(numberValue) ? numberValue : 0;
    },
    // 同步配置顶部“有告警”只看 overview 根因字段；接口未返回时再回退旧统计字段兼容历史数据。
    currentRootCauseAlertCount() {
      const unitCodeNotMatchedCount = this.firstNumber(this.currentOverview, ["unitCodeNotMatchedCount"]);
      const multipleMatchedCount = this.firstNumber(this.currentOverview, ["multipleMatchedCount"]);
      if (unitCodeNotMatchedCount === null && multipleMatchedCount === null) {
        return null;
      }
      return (unitCodeNotMatchedCount || 0) + (multipleMatchedCount || 0);
    },
    // 同步配置今日成功率优先兼容后端可能返回 0-1 或 0-100 两种口径，统一转成百分比整数展示。
    normalizeTodaySuccessRate(value) {
      const rate = this.toNumber(value);
      if (rate <= 0) return 0;
      return rate <= 1 ? Math.round(rate * 100) : Math.round(rate);
    },
    firstNumber(source, fields) {
      for (const field of fields) {
        if (source[field] !== undefined && source[field] !== null) {
          return this.toNumber(source[field]);
        }
      }
      return null;
    },
    shortSystemName(system) {
      const names = {
        UC: "UC",
        IHOTEL: "iHotel",
        ICATER: "iCater"
      };
      return names[system] || systemName(system);
    },
    // 连通性探活需要按指定业务系统读取配置，避免切换页签时误拿上一个系统的数据。
    getSystemConfig(system) {
      const remoteConfig = this.configs.find(item => item.downstreamSystem === system) || {};
      return {
        ...remoteConfig,
        ...(this.localConfigs[system] || {})
      };
    },
    getSystemOverview(system) {
      return (this.overview.downstreams || []).find(item => item.downstreamSystem === system) || {};
    },
    ensureCurrentSystem() {
      const tabValues = this.systemTabs.map(item => item.value);
      if (!tabValues.length) {
        if (this.currentSystem) {
          this.currentSystem = "";
          this.$emit("update:active-system", "");
        }
        return;
      }
      // 当前系统不在真实配置列表中时，回落到第一个真实系统，清掉历史假数据选中态。
      if (!tabValues.includes(this.currentSystem)) {
        this.currentSystem = tabValues[0];
        this.$emit("update:active-system", this.currentSystem);
      }
    },
    fillQueryUrl() {
      this.queryUrl = this.currentConfig.downstreamBaseUrl || this.currentOverview.downstreamBaseUrl || "";
    },
    getSystemQueryUrl(system) {
      const config = this.getSystemConfig(system);
      const overview = this.getSystemOverview(system);
      return config.downstreamBaseUrl || overview.downstreamBaseUrl || "";
    },
    getSystemWebhookEndpoint(system) {
      const config = this.getSystemConfig(system);
      const overview = this.getSystemOverview(system);
      return config.webhookEndpoint || overview.webhookEndpoint || "";
    },
    // 配置查询接口返回后以服务端最新配置为准，避免自动获取或保存前的本地缓存覆盖新值。
    clearLocalConfigsByRemote(configs = []) {
      configs.forEach(item => {
        const system = item.downstreamSystem;
        if (system && this.localConfigs[system]) {
          this.$delete(this.localConfigs, system);
        }
      });
    },
    // 切换目标系统时同步父级状态，保证保存后刷新仍停留在当前配置。
    selectConfigSystem(system) {
      this.currentSystem = system;
      this.$emit("update:active-system", system);
      this.fillQueryUrl();
      // 业务系统切换后必须重新调用探活接口，不能复用上一次缓存结果。
      this.syncConnectionStatus({
        force: true
      });
    },
    optionalPayload(payload) {
      return Object.keys(payload).reduce((result, key) => {
        const value = payload[key];
        if (value !== undefined && value !== null && value !== "") {
          result[key] = value;
        }
        return result;
      }, {});
    },
    oneClickPayload() {
      return this.optionalPayload({
        appId: this.appId,
        unitCode: this.unitCode,
        downstreamSystem: this.currentSystem,
        addressServiceAppCode: this.currentConfig.addressServiceAppCode || this.currentOverview.addressServiceAppCode || this.currentSystem,
        webhookPath: this.currentConfig.webhookPath || this.currentOverview.webhookPath,
        downstreamBasePath: this.currentConfig.downstreamBasePath || this.currentOverview.downstreamBasePath,
        secret: this.currentConfig.secret || this.currentOverview.secret,
        enabled: this.currentConfig.enabled !== undefined ? this.currentConfig.enabled : this.currentOverview.enabled !== undefined ? this.currentOverview.enabled : true,
        remark: this.currentConfig.remark || this.currentOverview.remark || `${this.shortName}${" " + $t('i5m2p64', '账号同步') + ""}`
      });
    },
    mergeOneClickConfig(retVal) {
      const syncConfig = (retVal === null || retVal === void 0 ? void 0 : retVal.syncConfig) || {};
      const webhookSubscription = (retVal === null || retVal === void 0 ? void 0 : retVal.webhookSubscription) || {};
      return {
        ...syncConfig,
        downstreamSystem: syncConfig.downstreamSystem || this.currentSystem,
        channelId: syncConfig.channelId || webhookSubscription.channelId || webhookSubscription.id,
        webhookEndpoint: syncConfig.webhookEndpoint || webhookSubscription.webhookEndpoint || webhookSubscription.target,
        downstreamBaseUrl: syncConfig.downstreamBaseUrl || (retVal === null || retVal === void 0 ? void 0 : retVal.downstreamBaseUrl) || ""
      };
    },
    // 自动获取调用文档 3.1 一键配置接口，由后端生成/复用 webhook channel 并返回最终配置。
    // 失败提示交给 http 拦截器统一处理，避免同步配置页重复弹窗。
    async autoFetchQueryUrl() {
      if (!this.currentSystem) return;
      this.autoFetching = true;
      try {
        const {
          data: {
            result,
            retVal
          }
        } = await oneClickDownstreamSyncConfig(this.oneClickPayload());
        if (result === 0) {
          const nextConfig = this.mergeOneClickConfig(retVal);
          this.$set(this.localConfigs, this.currentSystem, {
            ...this.currentConfig,
            ...nextConfig
          });
          this.queryUrl = nextConfig.downstreamBaseUrl || this.queryUrl;
          this.$Message.success($t("twzd8i6", "一键配置成功"));
          this.$emit("saved");
        }
      } finally {
        this.autoFetching = false;
      }
    },
    connectionDetailText(retVal) {
      const details = [retVal === null || retVal === void 0 ? void 0 : retVal.webhook, retVal === null || retVal === void 0 ? void 0 : retVal.downstreamBase].filter(Boolean).map(item => item.message || item.url).filter(Boolean);
      return details.length ? details.join("；") : "";
    },
    webhookEndpoint() {
      return this.currentConfig.webhookEndpoint || this.currentOverview.webhookEndpoint || "";
    },
    buildConnectionPayload(system, overrides = {}) {
      return {
        unitCode: this.unitCode,
        downstreamSystem: system,
        webhookEndpoint: overrides.webhookEndpoint !== undefined ? overrides.webhookEndpoint : this.getSystemWebhookEndpoint(system),
        downstreamBaseUrl: overrides.downstreamBaseUrl !== undefined ? overrides.downstreamBaseUrl : this.getSystemQueryUrl(system)
      };
    },
    // 状态标签只需要记录“是否连接失败”，下方结果卡片仍沿用单独的展示数据。
    setConnectionStatus(system, payload, failed, message = "") {
      const nextStatus = {
        failed,
        message,
        checkedAt: Date.now(),
        requestKey: JSON.stringify(payload)
      };
      this.$set(this.connectionStatusMap, system, nextStatus);
      return nextStatus;
    },
    // 默认进入页面和切换业务系统时自动静默探活，同一份参数不重复请求。
    async probeConnectionStatus(system, options = {}) {
      var _this$connectionStatu, _this$connectionStatu2;
      const {
        silent = true,
        force = false,
        payloadOverrides = {}
      } = options;
      if (!system || !this.unitCode) return null;
      const payload = this.buildConnectionPayload(system, payloadOverrides);
      const requestKey = JSON.stringify(payload);
      if (!force && this.probingSystems[system] === requestKey) {
        return this.connectionStatusMap[system] || null;
      }
      if (!force && ((_this$connectionStatu = this.connectionStatusMap[system]) === null || _this$connectionStatu === void 0 ? void 0 : _this$connectionStatu.requestKey) === requestKey && (_this$connectionStatu2 = this.connectionStatusMap[system]) !== null && _this$connectionStatu2 !== void 0 && _this$connectionStatu2.checkedAt) {
        return this.connectionStatusMap[system];
      }
      this.$set(this.probingSystems, system, requestKey);
      try {
        const {
          data: {
            result,
            retVal,
            msg
          }
        } = await testDownstreamConnection(payload, silent ? {
          headers: {
            nomsg: true
          }
        } : {});
        const detailText = this.connectionDetailText(retVal);
        return this.setConnectionStatus(system, payload, !(result === 0 && retVal !== null && retVal !== void 0 && retVal.success), detailText || msg || $t("x0kyyzg", "连通性测试暂不可用，请稍后重试。"));
      } catch (error) {
        return this.setConnectionStatus(system, payload, true, (error === null || error === void 0 ? void 0 : error.message) || $t("x0kyyzg", "连通性测试暂不可用，请稍后重试。"));
      } finally {
        if (this.probingSystems[system] === requestKey) {
          this.$delete(this.probingSystems, system);
        }
      }
    },
    syncConnectionStatus(options = {}) {
      if (!this.currentSystem) return;
      this.probeConnectionStatus(this.currentSystem, {
        silent: true,
        ...options
      });
    },
    // 连通性测试必须调用专用探活接口，不能再用配置查询接口模拟成功。
    async testConnection() {
      if (!this.currentSystem) return;
      this.testing = true;
      const system = this.currentSystem;
      const payload = this.buildConnectionPayload(system, {
        downstreamBaseUrl: this.queryUrl
      });
      const startedAt = Date.now();
      try {
        const {
          data: {
            result,
            retVal,
            msg
          }
        } = await testDownstreamConnection(payload);
        const responseTime = Date.now() - startedAt;
        const detailText = this.connectionDetailText(retVal);
        if (result === 0 && retVal !== null && retVal !== void 0 && retVal.success) {
          var _retVal$webhook, _retVal$downstreamBas;
          this.setConnectionStatus(system, payload, false);
          this.$set(this.connectionResults, system, {
            status: "success",
            icon: "ios-checkmark",
            title: `${"" + $t('6odzdvb', '连通成功 · 响应时间') + " "}${((_retVal$webhook = retVal.webhook) === null || _retVal$webhook === void 0 ? void 0 : _retVal$webhook.costMs) || ((_retVal$downstreamBas = retVal.downstreamBase) === null || _retVal$downstreamBas === void 0 ? void 0 : _retVal$downstreamBas.costMs) || responseTime}ms`,
            message: detailText || `${this.shortSystemName(system)}${" " + $t('kyeldjr', '同步通道连通，Webhook 与主动查询服务探活通过。') + ""}`
          });
        } else {
          const failedMessage = detailText || msg || $t("x0kyyzg", "连通性测试暂不可用，请稍后重试。");
          this.setConnectionStatus(system, payload, true, failedMessage);
          this.$set(this.connectionResults, system, {
            status: "error",
            icon: "ios-close",
            title: $t("d1rj434", "操作失败"),
            message: failedMessage
          });
        }
      } catch (error) {
        const failedMessage = (error === null || error === void 0 ? void 0 : error.message) || $t("x0kyyzg", "连通性测试暂不可用，请稍后重试。");
        this.setConnectionStatus(system, payload, true, failedMessage);
        this.$set(this.connectionResults, system, {
          status: "error",
          icon: "ios-close",
          title: $t("d1rj434", "操作失败"),
          message: failedMessage
        });
      } finally {
        this.testing = false;
      }
    },
    async saveConfig() {
      this.saving = true;
      try {
        const channelId = this.currentConfig.channelId || this.currentOverview.channelId;
        const {
          data: {
            result
          }
        } = await saveDownstreamSyncConfig({
          id: this.currentConfig.id || undefined,
          appId: this.appId,
          unitCode: this.unitCode,
          downstreamSystem: this.currentConfig.downstreamSystem || this.currentSystem,
          enabled: this.currentConfig.enabled !== undefined ? this.currentConfig.enabled : this.currentOverview.enabled,
          channelId,
          downstreamBaseUrl: this.queryUrl,
          remark: this.currentConfig.remark
        });
        if (result === 0) {
          // 保存成功后先按当前输入值回显，随后父级重新查询配置会用接口最新值覆盖本地缓存。
          this.$set(this.localConfigs, this.currentSystem, {
            ...this.currentConfig,
            downstreamSystem: this.currentConfig.downstreamSystem || this.currentSystem,
            downstreamBaseUrl: this.queryUrl
          });
          this.$Message.success($t("aghf564", "保存成功"));
          this.$emit("saved");
        }
      } finally {
        this.saving = false;
      }
    }
  }
};